import 'react-datepicker/dist/react-datepicker.css';
import { toast } from 'react-toastify';
import { useEffect, useMemo, useState } from 'react';
import Button from '../../../components/common/buttons/Button';
import LeaderboardTable from '../../../components/common/admin/LeaderboardTable';
import axios from 'axios';

type Item = {
    order: string;
    name: string;
    time: string;
};
export default function Leaderboard() {
    const [zdarData, setZdarData] = useState<Item[]>([]);
    const [kidsData, setKidsData] = useState<Item[]>([]);

    useEffect(() => {
        onReload();
    }, []);

    const onReload = () => {
        axios.get(process.env.REACT_APP_GCP_BE_URI + '/api/games/leaderboard').then(
            (response) => {
                setZdarData(response.data.zdarGame);
                setKidsData(response.data.kidsGame);
            },
            (error) => {
                console.log(error);
                toast('Data se nenačetli.', { type: 'error' });
            },
        );
    };

    const columnsZdar = useMemo(
        () => [
            {
                Header: 'Pořadí',
                accessor: 'order',
            },
            {
                Header: 'Jméno týmu',
                accessor: 'name',
            },
            {
                Header: 'Čas',
                accessor: 'time',
            },
        ],
        [],
    );

    const columnsKids = useMemo(
        () => [
            {
                Header: 'Pořadí',
                accessor: 'order',
            },
            {
                Header: 'Jméno týmu',
                accessor: 'name',
            },
            {
                Header: 'Čas',
                accessor: 'time',
            },
        ],
        [],
    );
    return (
        <div className="admin-screen">
            <div className="admin-page">
                <div className="admin-top-buttons">
                    <div className="leaderboard-heading">Pořadí týmů</div>
                    <div className="admin-top-right">
                        <Button className="secondary-button" onClick={() => onReload()}>
                            Aktualizovat data
                        </Button>
                    </div>
                </div>

                <div className="leaderboard-title">Žďárska únikovka</div>
                <LeaderboardTable columns={columnsZdar} data={zdarData} />

                <div className="leaderboard-title">Dětská únikovka</div>
                <LeaderboardTable columns={columnsKids} data={kidsData} />
            </div>
        </div>
    );
}
